import React from "react";

type WarningNoteProps = {
  label?: string;
  children: React.ReactNode;
};

export function WarningNote({ label, children }: WarningNoteProps) {
  return (
    <div className="my-8 text-left relative card-warning">
      {/* Header bar */}
      <div className="pl-5 pr-4 py-2.5 bg-[var(--rust-tint)] border-b border-[var(--border)] rounded-t flex items-center gap-2">
        {/* Warning Icon */}
        <svg 
          className="w-3.5 h-3.5 text-[var(--rust)] shrink-0" 
          fill="none" 
          viewBox="0 0 24 24" 
          stroke="currentColor" 
          strokeWidth={2.5}
          aria-hidden="true"
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
        </svg>
        <span className="text-[10px] font-mono font-bold tracking-widest text-[var(--rust-dark)] dark:text-[var(--foreground)] uppercase select-none">
          {label || "Reality Check"}
        </span>
      </div>
      
      {/* Content area */}
      <div className="warning-note-content pl-5 pr-5 py-4 text-sm text-[var(--ink-soft)] leading-relaxed font-sans font-medium">
        {children}
      </div>
    </div>
  );
}
